export enum GenericActivityListTimeFrameStrToTimeWindows {
	END_OF_NEXT_MONTH = 'last day of next month 00:00',
	END_OF_TOMORROW = 'tomorrow 23:59',
	LAST_MONTH = 'first day of last month 00:00',
	LAST_WEEK = '-1 week 00:00',
	NEXT_MONTH = 'first day of next month 00:00',
	NEXT_WEEK = 'next week 00:00',
	NEXT_YEAR = 'first day of next year 00:00',
	THIS_MONTH = 'first day of this month 00:00',
	THIS_WEEK = 'this week 00:00',
	THIS_YEAR = 'this year 00:00',
	TODAY = 'today 00:00',
	TOMORROW = 'tomorrow 00:00',
	YESTERDAY = 'yesterday 00:00',
}

export enum GenericActivityListTimeFrameWindows {
	END_OF_NEXT_MONTH = 'END_OF_NEXT_MONTH',
	END_OF_TOMORROW = 'END_OF_TOMORROW',
	LAST_MONTH = 'LAST_MONTH',
	LAST_WEEK = 'LAST_WEEK',
	NEXT_MONTH = 'NEXT_MONTH',
	NEXT_WEEK = 'NEXT_WEEK',
	NEXT_YEAR = 'NEXT_YEAR',
	OLDER_THAN_A_MONTH = 'OLDER_THAN_A_MONTH',
	THIS_MONTH = 'THIS_MONTH',
	THIS_WEEK = 'THIS_WEEK',
	THIS_YEAR = 'THIS_YEAR',
	TODAY = 'TODAY',
	TOMORROW = 'TOMORROW',
	YESTERDAY = 'YESTERDAY',
}

export enum GenericActivityListColumnNames {
	CHANNEL = 'CHANNEL',
	CONTACT = 'CONTACT',
	INFORMATION = 'INFORMATION',
	MODULE_INFORMATION = 'MODULE_INFORMATION',
	TIMESTAMP = 'TIMESTAMP',
}

export type GenericActivityListColumns = {
	name: GenericActivityListColumnNames;
	sortOrder: number;
	translationIdentifier: string;
	visible: boolean;
};

export type GenericActivityListSort = {
	direction: 'ASC' | 'DESC';
	property: string;
};

export type GenericActivityListTabPanelSort = {
	iconCls: string;
	labelIdentifier: string;
	sort: GenericActivityListSort;
};

// Der Sort gehört nicht hierher: Quelle ist `state.sort` des jeweiligen Stores (`sortFor(view)`), die
// Listen-Queries bekommen ihn als eigenes Konstruktor-Argument (Spec F8).
export type GenericActivityListPagination = {
	page: number;
	rowsPerPage: number;
};

export enum ActivityListTypeEnum {
	ALL = 'ALL',
	ALL_MODULE_LISTS_AT_ONCE = 'ALL_MODULE_LISTS_AT_ONCE',
	FILTER = 'FILTER',
	IDO = 'IDO',
	IDO_ACTIVITY_HISTORY_LIST = 'IDO_ACTIVITY_HISTORY_LIST',
	IDO_ACTIVITY_HISTORY_LIST_BY_IDO_AND_INSTANCE_ID = 'IDO_ACTIVITY_HISTORY_LIST_BY_IDO_AND_INSTANCE_ID',
	MINE = 'MINE',
	OPEN = 'OPEN',
}

export enum MODULE_LIST_TYPE {
	ALL = 'ALL',
	AUTOMATIC = 'AUTOMATIC',
	MINE = 'MINE',
	OPEN = 'OPEN',
}

export enum MODULE {
	AGENDA_LIST = 'agendaList',
	DOCUMENT_LIST = 'documentList',
	FILTER_LIST = 'filterList',
	IDO_HISTORY = 'record',
	IDO_LIST = 'records',
	IDO_PRINT = 'recordsPrint',
	INBOX = 'inbox',
	KANBAN_BOARD = 'kanbanBoard',
	MAIL_LIST = 'mailList',
	MESSAGE_LIST = 'messageList',
	NOTE_LIST = 'noteList',
	NOTEBOOK_LIST = 'notebookList',
	PHONE_CALL_LIST = 'phoneCallList',
	TASK_LIST = 'taskList',
	TRASH_LIST = 'trashList',
}
